<template>
  <div class="public-navbar">
    <v-toolbar v-resize="onResize" fixed app clipped-left
      color="white"
      :class="{ [`pt-${isMobile ? 0 : 0}`]: true }"
    >
      <!-- Menu Movil -->
      <v-toolbar-side-icon v-if="isMobile" color="primary" alt="Mostrar menu" aria-label="Menu" @click="showMenu = true"></v-toolbar-side-icon>
      <router-link to="/" style="margin: auto;padding-right: 36px;">
        <img class="rclogo" :alt="`${brandName} logo`" :src="logoUrl"/>
      </router-link>
      <img v-if="isAuthenticated && $route.path.startsWith('/panel')" class="invlogo" :alt="`${brandName} logo`" :src="urlimag"/>
      <!-- Menu Desk -->
      <v-toolbar-items v-if="!isMobile" style="width:100%"> 
        <v-spacer></v-spacer>
        <!-- <v-menu offset-y v-if="!isAuthenticated"> -->
        <v-btn v-show="isAuthenticated && user.user_tipo_id == 1" to="/admin/asociar" flat color="primary">Controlar cuenta</v-btn>
        <v-btn v-show="!isAuthenticated"
               class="ml-2 "
               style="text-transform:capitalize;height: auto;padding: 5px 17px;font-size:1rem !important;font-weight:600;font-family:'SF Pro Text', sans-serif"
               outline
               round
               color="primary"
               to="/registrar"
        >
          Registrarse
        </v-btn>
        <v-btn v-show="!isAuthenticated"
               class="ml-2 "
               style="text-transform:capitalize;height: auto;padding: 5px 17px;font-size:1rem !important;font-weight:600;font-family:'SF Pro Text', sans-serif"
               outline
               round
               color="primary"
               to="/login"
        >
          Ingresar
        </v-btn>

          <v-menu offset-y v-if="isAuthenticated">
          <template v-slot:activator="{ on }">
            <v-btn
              class="ml-0 nav-1000 hidden-sm-and-down"
              v-if="isAuthenticated"
              flat
              color="primary"
              v-on="on"
              >{{ user.nombre }} {{ user.app_pat }}
              <v-icon>expand_more</v-icon></v-btn
            >
          </template>
          <v-list>
            <v-list-tile @click="panelFacture()">
              <v-list-tile-title class="ml-0 nav-1000 hidden-sm-and-down" flat>
                Panel Solicitante
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-title class="ml-0 nav-1000 hidden-sm-and-down" flat>
                Cerrar sesión
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    
    <!-- Menu Movil RC HOME --> 
	<v-navigation-drawer v-model="showMenu"  left app fixed temporary class="rc-menuDrawerSitios">
		<v-list class="transparent pa-2" >
      <v-list-tile class="v-list-item rc-list-itemNav rc-listItem-pad" v-if="isAuthenticated && user.user_tipo_id == 1" to="/admin/asociar">
				<div style="text-align: center; width: 100%; line-height: 1;">
					<div class="rc-listItem-title">Controlar cuenta</div>
				</div>
			</v-list-tile>
      <!-- Invertir -->
			<v-list-tile class="v-list-item rc-list-itemNav rc-listItem-pad" v-if="!isAuthenticated" to="/registrar">
				<div style="text-align: center; width: 100%; line-height: 1;">
					<div class="rc-listItem-title">Crear cuenta</div>
				</div>
			</v-list-tile>
			<v-list-tile class="v-list-item rc-list-itemNav rc-listItem-pad" v-if="!isAuthenticated" @click="login">
				<div style="text-align: center; width: 100%; line-height: 1;">
					<div class="rc-listItem-title">Ingresar</div>
				</div>
			</v-list-tile>
			<!-- Menús móvil del solicitante -->
			<v-list-group class="rc-list-itemNav rc-listNameUser" v-if="isAuthenticated">
				<template v-slot:activator>
					<div style="text-align: center; width: 100%; line-height: 1;">
						<span class="rc-listItem-img material-icons" style="height:26px;width:26px">account_circle</span>
						<div class="rc-listItem-title">{{ nombreCompleto }}</div>
					</div>
				</template>
        <v-list-tile
          class="v-list-item rc-list-item rc-listItem-pad"
          @click="panelFacture()"
        >
          <div style="text-align: center; width: 100%; line-height: 1;">
            <span class="rc-listItem-img material-icons-outlined" style="height:26px;width:26px">dashboard</span>
            <div class="rc-listItem-title">Panel Solicitante</div>
          </div>
        </v-list-tile>
				<v-list-tile class="v-list-item rc-listItem-pad rc-listCerrarSesion" :active-class="activeClassMenu" @click="logout">
					<div style="text-align: center; width: 100%; line-height: 1;">
						<v-icon class="rc-listItem-img">logout</v-icon>
						<div class="rc-listItem-title">Cerrar sesión</div>
					</div>
				</v-list-tile>
			</v-list-group>
		</v-list>
	</v-navigation-drawer>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import { EventBus } from "@/main";
import { RedCapital, RedCapitalConfig, SelectedCountry } from "@/configuration";
import { themeService } from "@/services/themeService";

@Component({
  computed: {
    ...mapState(["user", "menu", "businesSelected"]),
    ...mapGetters(["isAuthenticated"]),
    logoUrl() {
      return themeService.current.brand.logoUrl || RedCapital[SelectedCountry].Logo;
    },
    brandName() {
      return themeService.current.brand.brandName;
    },
    activeClass() {
      return "primary white--text";
    },
    urlimag() {
      return "/images/sitio-solicitante.png";
    },
    activeClassMenu() {
      return "rc-menuPanelActive";
    },
    nombreUser(){
      if(this.$store.state.user != null){
        this.$data.nombreCompleto = this.capitalize(this.$store.state.user.nombre)+' '+this.capitalize(this.$store.state.user.app_pat);
        return this.$data.nombreCompleto;
      }
    }
  },
  data() {
    return {
      SelectedCountry,
      RedCapital,
      nombreCompleto: null,
      canShowUserMenu: false,
      showMenu: false,
      isMobile: true,
    };
  },
  methods: {
    panelFacture() {
      this.$store.commit("setMenu", 3);
       this.$router.push("/panel-facto/estadisticas");
    },
    onResize() {
      if (window.innerWidth <= 1270) { /* Old 1080 */ /* 960 Old */
        this.$data.isMobile = true;
      } else {
        this.$data.isMobile = false;
        this.$data.showMenu = false;
      }
    },
    login() {
      this.$data.showMenu = false;
      this.$data.canShowUserMenu = false;
      EventBus.$emit("open-login-dialog");
    },
    logout() {
      EventBus.$emit("logout");
    },
    capitalize(texto){ // #Pendiente dejar esta funcion global para llamar donde sea.
      const lower = texto.toLowerCase();
      return texto.charAt(0).toUpperCase()+lower.slice(1); 
    }
  },
  beforeMount() {
    if(this.$store.state.user != null){
      this.$data.nombreCompleto = this.capitalize(this.$store.state.user.nombre)+' '+this.capitalize(this.$store.state.user.app_pat);
    }
  },
  watch: {
    nombreUser(newVal, oldVal){
      if(newVal != undefined || newVal != null ){
        this.$data.nombreCompleto = newVal
      }
    }
  }
})
export default class NavBar extends Vue {}
</script>

<style lang="scss" scoped>
.font-OneRem{
  font-size: 1rem !important;
  font-weight: 500 !important;
}
.navbar {
  z-index: 3;
}
.rclogo {
  @media (max-width: 960px) {
    height: 40px;
  }
  @media (min-width: 960px) {
    height: 50px;
  }
}
.invlogo {
  @media (max-width: 960px) {
    height: 20px;
  }
  @media (min-width: 960px) {
    height: 25px;
  }
}
.dis-none {
  @media (max-width: 600px) {
    display: none;
  }
}

.v-menu__content {
  position: fixed !important;
  border-radius: 1rem !important;
}
.active {
  box-shadow: 0px -2px 5px 0px rgb(195 87 14);
  //box-shadow: 4px 0 0px -2px #888;
  color: white;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}
.btnsitio {
  background-color: #ecded4 !important;
  color: #c3570f;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}
.active2 {
  //box-shadow: 0px -2px 5px 0px rgb(195 87 14);
  //box-shadow: 4px 0 0px -2px #888;
  color: white;
  //border-radius: 0.325rem 0.325rem 0px 0px;
}
.btnsitio2 {
  background-color: #ecded4 !important;
  color: #c3570f;
  //border-radius: 0.325rem 0.325rem 0px 0px;
}
.positionabs{
      position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: -36px;
    text-align: right;
    right: 0;
}

// MENU
.rc-listItem-title{
	font-weight: 600;
}
// Breakpoints 
@each $breakpoint in $breakpoints_screen_text{
	@include breakpoint_media_queries($breakpoint){
		@if $breakpoint == "x-large"{
			
		}@else if $breakpoint == "large"{
			
		}@else if $breakpoint == "medium-to-large"{
			.rc-menuDrawerSitios{
				margin-top: 0 !important;
				z-index: 5;
				width: 300px !important;
			}
			.rc-listItem-img{
				float: left;
			}
			.rc-listItem-title{
				float: left;
				line-height: 2;
				margin-left: 10px;
			}
		}@else if $breakpoint == "small-to-medium"{
			.rc-menuDrawerSitios{
				margin-top: 0 !important;
				z-index: 5;
				width: 300px !important;
			}
			.rc-listItem-img{
				float: left;
			}
			.rc-listItem-title{
				float: left;
				line-height: 2;
				margin-left: 10px;
			}
		}@else if $breakpoint == "small"{
			.rc-menuDrawerSitios{
				margin-top: 0 !important;
				z-index: 5;
				width: 300px !important;
			}
			.rc-listItem-img{
				float: left;
			}
			.rc-listItem-title{
				float: left;
				line-height: 2;
				margin-left: 10px;
			}
		}
	}
}

/*.rc-listCerrarSesion{
	a{
		div{
			i{
				color: $rc-prim-n1 !important;
			}
			div
			{
				color: $rc-prim-n1 !important;
				font-weight: 600;
			}
		}
	}
}*/

.public-navbar .v-toolbar {
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
}

</style>
